import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var SpinnerConst;
(function (SpinnerConst) {
    SpinnerConst["SPINNER"] = "spinner";
    SpinnerConst["SPINNER_CENTER"] = "se-fe-spinner--center";
})(SpinnerConst || (SpinnerConst = {}));
var SpinnerSizeConst;
(function (SpinnerSizeConst) {
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_200"] = 200] = "SPINNER_SIZE_200";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_500"] = 500] = "SPINNER_SIZE_500";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_600"] = 600] = "SPINNER_SIZE_600";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_700"] = 700] = "SPINNER_SIZE_700";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_800"] = 800] = "SPINNER_SIZE_800";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_900"] = 900] = "SPINNER_SIZE_900";
    SpinnerSizeConst[SpinnerSizeConst["SPINNER_SIZE_950"] = 950] = "SPINNER_SIZE_950";
})(SpinnerSizeConst || (SpinnerSizeConst = {}));
class SeFeSpinnerComponent {
    constructor() {
        this.isVisible = false;
        this.size = 500;
        this.delay = 0;
        this.seFeDataAriaLabel = 'loading';
        this.sizeMap = {
            'page': SpinnerSizeConst.SPINNER_SIZE_900,
            'content': SpinnerSizeConst.SPINNER_SIZE_800,
            'section': SpinnerSizeConst.SPINNER_SIZE_800,
            'inline': SpinnerSizeConst.SPINNER_SIZE_500,
            'inline-small': SpinnerSizeConst.SPINNER_SIZE_200,
        };
    }
    // Deprecated
    set useInverted(val) {
        console.warn('[seFeDataInverted] is deprecated.');
    }
    get classes() { return this.spinnerClasses; }
    get display() {
        return !this.isVisible ? 'none' : null;
    }
    ngOnInit() {
        if (this.delay === 0) {
            this.isVisible = true;
            return;
        }
        this.delayTimeout = setTimeout(() => {
            this.isVisible = true;
        }, this.delay);
    }
    ngOnDestroy() {
        if (this.delayTimeout)
            clearTimeout(this.delayTimeout);
    }
    get spinnerClasses() {
        const sizeNum = this.getSize(this.size);
        const alignmentClass = this.getAlignmentClass(sizeNum);
        return `se-fe-spinner--${sizeNum} ${alignmentClass} `;
    }
    getSize(size) {
        if (typeof size === 'string') {
            return this.sizeMap[size] ?? SpinnerSizeConst.SPINNER_SIZE_500;
        }
        return this.isSizeValid(size) ? size : SpinnerSizeConst.SPINNER_SIZE_500;
    }
    getAlignmentClass(size) {
        if (this.alignCenter === undefined && size > 500)
            return SpinnerConst.SPINNER_CENTER;
        return this.alignCenter ? SpinnerConst.SPINNER_CENTER : '';
    }
    isSizeValid(size) {
        return Object.values(SpinnerSizeConst).some((v) => v === size);
    }
}
SeFeSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SeFeSpinnerComponent, selector: "se-fe-spinner", inputs: { size: ["seFeDataSize", "size"], useInverted: ["seFeDataInverted", "useInverted"], delay: ["seFeDataDelay", "delay"], alignCenter: ["seFeDataCenter", "alignCenter"], seFeDataAriaLabel: "seFeDataAriaLabel" }, host: { properties: { "class": "this.classes", "style.display": "this.display" } }, ngImport: i0, template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" [attr.aria-label]=\"seFeDataAriaLabel\" role=\"img\">\n  <path fill=\"currentColor\" d=\"M12 24C5.373 24 0 18.627 0 12h2c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2c-.453 0-.897.034-1.334.092V.076C11.104.028 11.549 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12Z\"/>\n</svg>", styles: [":host{color:var(--se-spinner)}:host.se-fe-spinner--center{display:flex;justify-content:center}:host.se-fe-spinner--center.se-fe-spinner--950,:host.se-fe-spinner--center.se-fe-spinner--900,:host.se-fe-spinner--center.se-fe-spinner--800,:host.se-fe-spinner--center.se-fe-spinner--700,:host.se-fe-spinner--center.se-fe-spinner--600{padding:var(--se-content-spacing) 0}:host svg{animation:seSpin .6s linear infinite}@keyframes seSpin{to{transform:rotate(360deg)}}:host.se-fe-spinner--200 svg{height:15px;margin-bottom:0;width:15px}:host.se-fe-spinner--500 svg{height:20px;margin-bottom:-2px;width:20px}:host.se-fe-spinner--600 svg{height:22.5px;margin-bottom:-4px;width:22.5px}:host.se-fe-spinner--700 svg{height:25px;margin-bottom:-5px;width:25px}:host.se-fe-spinner--800 svg{height:42.5px;margin-bottom:-8px;width:42.5px}:host.se-fe-spinner--900 svg{height:56.25px;margin-bottom:-9px;width:56.25px}:host.se-fe-spinner--950 svg{height:96px;margin-bottom:-11px;width:96px}:host.se-fe-spinner--center svg{margin-bottom:0}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'se-fe-spinner', template: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" [attr.aria-label]=\"seFeDataAriaLabel\" role=\"img\">\n  <path fill=\"currentColor\" d=\"M12 24C5.373 24 0 18.627 0 12h2c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2c-.453 0-.897.034-1.334.092V.076C11.104.028 11.549 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12Z\"/>\n</svg>", styles: [":host{color:var(--se-spinner)}:host.se-fe-spinner--center{display:flex;justify-content:center}:host.se-fe-spinner--center.se-fe-spinner--950,:host.se-fe-spinner--center.se-fe-spinner--900,:host.se-fe-spinner--center.se-fe-spinner--800,:host.se-fe-spinner--center.se-fe-spinner--700,:host.se-fe-spinner--center.se-fe-spinner--600{padding:var(--se-content-spacing) 0}:host svg{animation:seSpin .6s linear infinite}@keyframes seSpin{to{transform:rotate(360deg)}}:host.se-fe-spinner--200 svg{height:15px;margin-bottom:0;width:15px}:host.se-fe-spinner--500 svg{height:20px;margin-bottom:-2px;width:20px}:host.se-fe-spinner--600 svg{height:22.5px;margin-bottom:-4px;width:22.5px}:host.se-fe-spinner--700 svg{height:25px;margin-bottom:-5px;width:25px}:host.se-fe-spinner--800 svg{height:42.5px;margin-bottom:-8px;width:42.5px}:host.se-fe-spinner--900 svg{height:56.25px;margin-bottom:-9px;width:56.25px}:host.se-fe-spinner--950 svg{height:96px;margin-bottom:-11px;width:96px}:host.se-fe-spinner--center svg{margin-bottom:0}\n"] }]
        }], propDecorators: { size: [{
                type: Input,
                args: ['seFeDataSize']
            }], useInverted: [{
                type: Input,
                args: ['seFeDataInverted']
            }], delay: [{
                type: Input,
                args: ['seFeDataDelay']
            }], alignCenter: [{
                type: Input,
                args: ['seFeDataCenter']
            }], seFeDataAriaLabel: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }] } });

class SeFeSpinnerModule {
}
SeFeSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerModule, declarations: [SeFeSpinnerComponent], imports: [CommonModule], exports: [SeFeSpinnerComponent] });
SeFeSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeSpinnerComponent],
                    imports: [CommonModule],
                    exports: [SeFeSpinnerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeSpinnerComponent, SeFeSpinnerModule, SpinnerConst, SpinnerSizeConst };
